module.exports = __webpack_public_path__ + "media/dorobek/assets/images/uczelnia-effd647e9c7b1e27ffc058311ad9668c.svg";